import React from 'react';
import styles from "./PrevButton.module.scss";
import AbstractButton
  from 'gui/components/editors/commons/editor/components/abstractDetailsForm/components/stepButtons/components/abstractButton';

interface IPrevButtonProps {
  submitForm?: any;
  isSubmitting?: boolean;
  setSubmitRef?: any;
  setFieldValue?: any;
  activeStep?: number;
  steps?: string[],

  loading?: boolean;
}

const getPrevStepLabel = ({
                            activeStep,
                            steps
                          }: any) => (activeStep >= 1) ? steps[activeStep - 1] : null;

const PrevButton = (props: IPrevButtonProps) => {
  const step = getPrevStepLabel(props);
  if (step) {
    return (<AbstractButton
      className={styles.prevButton}
      onClick={() => {
        props.setFieldValue("activeStep", props.activeStep - 1)
        props.submitForm();
      }}
      setSubmitRef={props.setSubmitRef}
      loading={props.loading}
    >
      {['חזור', ["ל", step].join("")].join(" ")}
    </AbstractButton>);
  }
  return (null)
};

PrevButton.defaultProps = {
  submitForm: () => {
  },
  isSubmitting: false,
  steps: [],
};

export default React.memo(PrevButton);
